var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['nut-icon', 'nut-icon-' + _vm.type],style:({ height: _vm.size, width: _vm.size, color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.icon)}})}
var staticRenderFns = []

export { render, staticRenderFns }